module.exports = __webpack_public_path__ + "static/media/pain-condition-intake.b153a7ad.png";